import * as React from "react"

const ArrowLeft = (props) => (
  <svg
    width={6}
    height={8}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m2.34 4 2.785 2.784-.795.796L.75 4 4.33.42l.795.796L2.341 4Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowLeft
